import React from 'react';
import getConfig from 'next/config';

import Icon from 'components/Icon';
import NextLink from 'components/NextLink';

import { useIsMobileWithBreakpoint } from 'hooks/useIsMobileWithBreakpoint';

import styles from './styles.module.scss';

const {
	publicRuntimeConfig: { assetPrefix }
} = getConfig();
// @TODO: Replace icon on chevronRoundedRight when merge persons
const AccessibilityPromoCard = () => {
	const isMobile = useIsMobileWithBreakpoint('mobileMedium');
	const imagePath = isMobile
		? `url("${assetPrefix}images/catalogs/accessibility-mobile.svg")`
		: `url("${assetPrefix}images/catalogs/accessibility-desktop.svg")`;

	return (
		<NextLink
			className={styles.AccessibilityPromoCard}
			href="/accessible-environment/russia"
			next
		>
			<div className={styles.AccessibilityPromoCard__Body}>
				<div className={styles.AccessibilityPromoCard__Title}>
					<div className={styles.AccessibilityPromoCard__AccentText}>
						Витрина <br />
						доступности
					</div>
					объектов <br />
					культуры
				</div>
				<div className={styles.AccessibilityPromoCard__More}>
					Подробнее
					<Icon
						icon="chevronRight"
						className={styles.AccessibilityPromoCard__Icon}
					/>
				</div>
			</div>
			<div
				className={styles.AccessibilityPromoCard__Image}
				style={{
					backgroundImage: imagePath
				}}
			/>
		</NextLink>
	);
};

export default AccessibilityPromoCard;
